// extracted by mini-css-extract-plugin
var _1 = "FSUuRWOuJw";
var _2 = "hM112K6oW1";
var _3 = "k6paATT0Dd";
var _4 = "PtCuzY6XwB";
export { _1 as "caption", _2 as "description", _3 as "legend", _4 as "root" }
